<template>
	<li class="question-card__answer answer-field" v-if="!answer._destroy" :class="{ 'answer-field--radio': is_question_with_single_answer }">
		<input type="hidden" :name="'questionnaire[questions_attributes][' + question_index + '][answers_attributes][' + answer_index + '][_destroy]'" v-model="answer._destroy">
		<input type="hidden" :name="'questionnaire[questions_attributes][' + question_index + '][answers_attributes][' + answer_index + '][id]'" v-model="answer.id">
		<input type="hidden" :name="'questionnaire[questions_attributes][' + question_index + '][answers_attributes][' + answer_index + '][answer_type]'" v-model="answer.answer_type">
		<input type="hidden" :name="'questionnaire[questions_attributes][' + question_index + '][answers_attributes][' + answer_index + '][pos]'" v-model="answer.pos">
		<label class="answer-field__field labeled-field" :class="[{ 'labeled-field--other': isOpenAnswer(answer) } ]">
			<input
				class="labeled-field__input"
				type="text"
				:name="'questionnaire[questions_attributes][' + question_index + '][answers_attributes][' + answer_index + '][title]'"
				:placeholder="isOpenAnswer(answer) ? t.other_placeholder : t.default_placeholder + ' ' + (answer_index + 1)"
				v-model.trim="answer.title"
				:disabled="isOpenAnswer(answer)"
				data-test-id="questionnaire-answer-title"
				@input="answerFieldUpdate(answer)"
				@change="flushAnswerUpdate(answer)"
				>
		</label>
		<button class="answer-field__remove-btn remove-btn remove-btn--red" type="button" :aria-label="t.remove_btn" @click.prevent="removeAnswer(answer)"></button>
	</li>
</template>

<script>
import axios from 'axios';
import { debounce } from 'vue-debounce';

export default {
	name: 'QuestionnairesAnswer',

	props: {
		answer: { type: Object, required: true },
		question_index: { type: Number, required: true },
		answer_index: { type: Number, required: true },
		is_question_with_single_answer: { type: Boolean, required: true, default: true }
	},

	data() {
		return {
			state: '',
			t: I18n.t.questionnaire_dashboard_form.fields.questionnaire.questions.answers
		}
	},

	created() {
		// Таймер свой у каждого варианта: debounce, объявленный в methods, общий на все экземпляры
		// и отменял сохранение соседнего поля при быстром вводе
		this.debouncedAnswerUpdate = debounce(answer => this.updateAnswer(answer), 800);
	},

	watch: {
		// Текст могли ввести раньше, чем сервер вернул адрес для сохранения варианта
		'answer.update_url'() {
			if (this.state == 'modified') this.debouncedAnswerUpdate(this.answer);
		}
	},

	methods: {
		isOpenAnswer(answer) {
			return answer.answer_type == 'open';
		},

		answerFieldUpdate(answer) {
			this.state = 'modified';
			this.debouncedAnswerUpdate(answer);
		},

		// Уход с поля сохраняет сразу, не дожидаясь таймера
		flushAnswerUpdate(answer) {
			if (this.state != 'modified') return;

			this.debouncedAnswerUpdate.cancel();
			this.updateAnswer(answer);
		},

		updateAnswer(answer) {
			if (!answer.update_url) return;

			axios({
				response_type: "json",
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
				},
				method: 'PATCH',
				url: answer.update_url,
				data: { answer }
			}).then(response => {
				this.state = 'synced';
			}).catch(errors => {
				this.state = 'error';
			})
		},

		removeAnswer(answer) {
			answer._destroy = true
			axios({
				response_type: "json",
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
				},
				method: 'DELETE',
				url: answer.update_url,
				data: {}
			}).then(response => {
				this.state = 'synced';
			}).catch(errors => {
				this.state = 'error';
			})
		},
	},
}
</script>

